"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dontRenderIfBothOnClickAndTo = void 0;
var react_1 = __importDefault(require("react"));
var Typo2_1 = require("../../Typo2");
var dontRenderIfBothOnClickAndTo = function (_a) {
    var onClick = _a.onClick, to = _a.to;
    if (onClick && to) {
        return (react_1.default.createElement(Typo2_1.UI_BODY_SEMIBOLD, { color: "red" }, "Only one prop is allowed for this component - \"to\" or \"onClick\" ."));
    }
    else {
        return undefined;
    }
};
exports.dontRenderIfBothOnClickAndTo = dontRenderIfBothOnClickAndTo;
